<template>
    <div class="d-flex justify-center align-center">
        <v-icon>mdi-weather-sunny</v-icon>
        <v-switch v-model="isDark" hide-details density="compact" class="mx-1"></v-switch>
        <v-icon>mdi-weather-night</v-icon>
    </div>
</template>

<script>
export default {
    name: 'ThemeSwitcher',
    computed: {
        isDark: {
            get() {
                return this.$vuetify.theme.global.current.dark;
            },
            set(val) {
                this.$vuetify.theme.global.name = val ? 'dark' : 'light';
            }
        }
    }
};
</script>
